import { CSSProgressiveHeading02 } from "@caisy/league";
import styled from "styled-components";

export const SCreateProjectCardTitle = styled.div`
  ${CSSProgressiveHeading02};
  color: var(--text-01);
  margin: 0 auto;
  text-align: center;
`;
